import List, { ListProps } from '@material-ui/core/List';
import * as React from 'react';
import { ListItemLoading } from '../ListItemLoading';

interface IStickyListProps extends Omit<ListProps, 'subheader' | 'children'> {
  children: React.ReactNode;
  isLoading?: boolean;
}

let StickyList: React.FunctionComponent<IStickyListProps> = ({ isLoading, children, ...listProps }) => {
  return (
    <List subheader={<li />} {...listProps}>
      {isLoading && <ListItemLoading />}
      {!isLoading && children}
    </List>
  );
};

StickyList = React.memo<IStickyListProps>(StickyList);
export { StickyList };
